import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ControlPoint } from "./ch-controlpoint";

interface CHServiceData {
    definitionId: string;
    name: string;
    categories: string[];
    instanceId?: string;
    controlPoints?: { [k: string]: ControlPoint };
    entertainmentServiceId?: string;
    startSequenceUid?: string;
    stopSequenceUid?: string;
    version?: string;
    widgetUrl?: string;
    zoneUids?: string[];
}

export class CHService {
    static readonly importMap: ImportMap<CHService, CHServiceData> = [
        { i: "definitionId", o: "definitionId" },
        { i: "name", o: "name" },
        { i: "categories", o: "categories" },
        { i: "instanceId", o: "instanceId" },
        { i: "controlPoints", o: "controlPoints" },
        { i: "entertainmentServiceId", o: "entertainmentServiceId" },
        { i: "startSequenceUid", o: "startSequenceUid" },
        { i: "stopSequenceUid", o: "stopSequenceUid" },
        { i: "version", o: "version" },
        { i: "widgetUrl", o: "widgetUrl" },
        { i: "zoneUids", o: "zoneUids" },
    ];

    isValid: boolean;
    isConfigured: boolean;
    roomNameArray: string[];
    units?: { [key: string]: { input: string; output: string } }; // used for tstat services when getting the degree units of measure
    supportedFeatures?: string[];

    static fromDbObject(service): CHService {
        let newService = new CHService(
            service[CHService.importMap[0].i],
            service[CHService.importMap[1].i],
            service[CHService.importMap[2].i],
            service[CHService.importMap[3].i],
            service[CHService.importMap[4].i],
            service[CHService.importMap[5].i],
            service[CHService.importMap[6].i],
            service[CHService.importMap[7].i],
            service[CHService.importMap[8].i],
            service[CHService.importMap[9].i],
            service[CHService.importMap[10].i]
        );

        // lite service info
        if (service.ServiceInstanceId) {
            newService.instanceId = service.ServiceInstanceId;
            newService.isValid = service.IsValid === "true";
            newService.isConfigured = service.IsConfigured === "true";
            newService.categories = service.CategoryNames;
            newService.roomNameArray = service.RoomNames;
            newService.definitionId = service.ServiceDefinitionId;
            newService.name = service.ServiceName;
            newService.supportedFeatures = service.SupportedFeatures;
        } else {
            if (!service.derivedServiceDevice && service.devicesUsedInService && service.devicesUsedInService.length === 1) {
                service.derivedServiceDevice = service.devicesUsedInService[0];
            }

            newService.isValid = true;
            newService.isConfigured = true;

            newService = Object.assign(newService, service);
        }

        return newService;
    }

    derivedServiceDevice: string;
    devicesUsedInService: string[] = [];

    constructor(
        public definitionId: string,
        public name: string,
        public categories: string[],
        public instanceId?: string,
        public controlPoints?: { [k: string]: ControlPoint },
        public entertainmentServiceId?: string,
        public startSequenceUid?: string,
        public stopSequenceUid?: string,
        public version?: string,
        public widgetUrl?: string,
        public zoneUids?: string[]
    ) {}
}
